import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import SEO from '../components/Seo'
import HeaderTitle from '../components/HeaderTitle'
import ContentBlock from '../components/ContentBlock'
import BackgroundDots from '../components/BackgroundDots'

const Dots = [
    {
        mobile: {
            x: 20,
            y: 400,
            position: 'right',
            ellipse: 20,
            circle: 150
        },
        desktop: {
            x: 100,
            y: 870,
            position: 'left',
            ellipse: 40,
            circle: 300
        }
    }
]

const Privacy = ({ data: { prismicPrivacy } }) => (

    <Layout theme='dark'>

        <SEO title={prismicPrivacy.data.title.text} />
        
        <HeaderTitle label={prismicPrivacy.data.title.text} />
        <ContentBlock data={prismicPrivacy.data.content.html}/>
        <BackgroundDots data={Dots} />

    </Layout>

)

export default Privacy

export const pageQuery = graphql`
    query PrivacyQuery {
        prismicPrivacy {
            data {
                title {
                    text
                }
                content {
                    html
                }
            }
        }
    }
`